import { type FC, useMemo } from 'react';

import { AccoCardsGroup } from '@vakantiesnl/components/src/organisms/AccoCardsGroup';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { useGetSimilarAccommodations } from '@vakantiesnl/services/src/hooks/queries/useGetSimilarAccommodations';
import { type Search } from '@vakantiesnl/types';

const NUMBER_OF_ACCOS_TO_RENDER = 8;

type Props = {
	accommodation: Search.FullAccommodationItem;
};

export const SimilarAccos: FC<Props> = ({ accommodation }) => {
	const microCopies = useMicroCopyContext();

	const accommodations = useGetSimilarAccommodations(accommodation);

	const similarAccos = useMemo(
		() => accommodations.filter((item) => item.id !== accommodation.id),
		[accommodation.id, accommodations],
	);

	if (similarAccos.length === 0) {
		return null;
	}

	return (
		<AccoCardsGroup
			heading={microCopies['similarAccos.title']}
			listDataCy="similarAccosList"
			accos={similarAccos.slice(0, NUMBER_OF_ACCOS_TO_RENDER)}
			accoItemDataCy="popularAccoItem"
			accoCardSize="tiny"
			pageType="accommodation"
			needQueryParams={false}
		/>
	);
};
